/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cashFrontendServiceCdpTrackEvent} from '../api'

export const useMutationCashFrontendServiceCdpTrackEvent = createReactQueryMutationHook('cashFrontendServiceCdpTrackEvent', cashFrontendServiceCdpTrackEvent)
